export default __webpack_public_path__ + "static/media/Home_BG-03.31c85c38.png";